import type { Components, Theme } from '@mui/material/styles';

export default function MuiInputLabel(theme: Theme): Components['MuiInputLabel'] {
  return {
    styleOverrides: {
      asterisk: {
        color: theme.palette.error.main,
        paddingLeft: '0.25rem',
      },
      root: {
        whiteSpace: 'break-spaces',
      },
      outlined: {
        position: 'static',
        transform: 'none',
        marginBottom: '4px',
        transition: 'none', // Prevent the "shrink" scale effect when focused
        fontSize: '15px',
        color: 'inherit',
        '&.Mui-focused': {
          color: 'inherit',
        },
        '&.Mui-error': {
          color: 'inherit',
        },
      },
    },
  };
}
